import { render, staticRenderFns } from "./familyFirstAidDetail.vue?vue&type=template&id=270f6584&scoped=true"
import script from "./familyFirstAidDetail.vue?vue&type=script&lang=js"
export * from "./familyFirstAidDetail.vue?vue&type=script&lang=js"
import style0 from "./familyFirstAidDetail.vue?vue&type=style&index=0&id=270f6584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f6584",
  null
  
)

export default component.exports